import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
Swiper.use([Navigation, Pagination, Lazy]);

export default function setProductSlider() {


    const vitrines = document.querySelectorAll('[data-vitrine]');
    vitrines.forEach(section => {

    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    var sliderSectionHome = new Swiper('#swiper-section', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 10,
        watchOverflow: true,
        pagination:true,
        navigation:true,
        pagination: {
            el: '.swiper-pagination-section',
            type: 'bullets',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
        },
    });
    var sliderSectionHome = new Swiper('#swiper-section-side', {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 10,
        watchOverflow: true,
        pagination:true,
        navigation:true,
        pagination: {
            el: '.swiper-pagination-section',
            type: 'bullets',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
        },
    });
    })
}
